import Clients from 'modules/Agency/Clients/Clients'
import Sagas from 'modules/Agency/Clients/saga'
import Reducer from 'modules/Agency/Clients/reducer'

export default Clients

export { Sagas, Reducer }
